import siteConfig from "../config/siteConfig";

const createProduct = ({ slug, attributes, ...product }) => {
  const imageBase = `${String(product.id).padStart(3, "0")}-${slug}`;
  const image = `/img/products/${imageBase}-01.jpg`;

  return {
    ...product,
    brand: siteConfig.brandName,
    currency: siteConfig.currency,
    image,
    images: [image, `/img/products/${imageBase}-02.jpg`],
    material: attributes.material,
    attributes,
    stock: true,
  };
};

const productData = [
  createProduct({
    id: 1,
    sku: "HN-W-001",
    slug: "avela-rippshirt",
    name: "Avela Rippshirt aus Bio-Baumwolle",
    category: "Damen",
    subcategory: "Shirts & Tops",
    price: "49.90",
    rating: 4.8,
    reviews: 126,
    badges: ["Bestseller"],
    colors: ["Naturweiß", "Salbeigrün", "Nachtblau"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Das fein gerippte Avela Shirt liegt weich auf der Haut und begleitet dich durch ruhige wie aktive Tage.",
      "Seine klare Linie, der runde Ausschnitt und die leicht verlängerten Ärmel machen es zu einem vielseitigen Lieblingsstück.",
    ],
    Features: [
      "Elastischer Feinripp",
      "Körpernahe, bequeme Passform",
      "Formstabile Bündchen",
      "Weiches Nackenband",
    ],
    attributes: {
      material: "97% Bio-Baumwolle, 3% Elasthan",
      fit: "Körpernah",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["bio-baumwolle", "basic", "ripp", "damen"],
  }),
  createProduct({
    id: 2,
    sku: "HN-W-002",
    slug: "linora-leinenbluse",
    name: "Linora Leinenbluse",
    category: "Damen",
    subcategory: "Blusen",
    price: "89.90",
    originalPrice: "119.90",
    rating: 4.7,
    reviews: 84,
    badges: ["Sale", "Neu"],
    colors: ["Kreide", "Sand", "Terrakotta"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Linora verbindet luftiges Leinen mit einer entspannten Silhouette und einem weich fallenden Stehkragen.",
      "Die feine Webstruktur gewinnt mit jedem Tragen an Charakter und fühlt sich an warmen Tagen angenehm kühl an.",
    ],
    Features: [
      "Verdeckte Knopfleiste",
      "Seitlich gerundeter Saum",
      "Breite Einknopfmanschetten",
      "Natürlich kühlendes Gewebe",
    ],
    attributes: {
      material: "100% Leinen",
      fit: "Locker",
      care: "30 °C Feinwäsche",
      origin: "Litauen",
      certification: "Europäischer Flachs",
    },
    tags: ["sale", "leinen", "sommer", "bluse", "damen"],
  }),
  createProduct({
    id: 3,
    sku: "HN-W-003",
    slug: "mirea-hanfshirt",
    name: "Mirea Hanf-Jerseyshirt",
    category: "Damen",
    subcategory: "Shirts & Tops",
    price: "59.90",
    rating: 4.6,
    reviews: 73,
    badges: ["Naturfaser"],
    colors: ["Eukalyptus", "Graphit", "Beere"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Der griffige Hanf-Jersey von Mirea ist atmungsaktiv, langlebig und überraschend weich.",
      "Eine lockere Schulterlinie und kleine Seitenschlitze geben dem Shirt seine moderne, unkomplizierte Form.",
    ],
    Features: [
      "Atmungsaktiver Hanf-Mix",
      "Überschnittene Schultern",
      "Seitliche Saumschlitze",
      "Vorgewaschene Oberfläche",
    ],
    attributes: {
      material: "55% Hanf, 45% Bio-Baumwolle",
      fit: "Entspannt",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["hanf", "jersey", "atmungsaktiv", "damen"],
  }),
  createProduct({
    id: 4,
    sku: "HN-W-004",
    slug: "elara-hemdbluse",
    name: "Elara Popeline-Hemdbluse",
    category: "Damen",
    subcategory: "Blusen",
    price: "79.90",
    rating: 4.8,
    reviews: 92,
    badges: ["Bestseller"],
    colors: ["Reinweiß", "Himmelblau", "Schilf"],
    size: ["34", "36", "38", "40", "42", "44", "46"],
    description: [
      "Elara interpretiert die klassische Hemdbluse mit einer großzügigen Falte im Rücken und fein abgerundeten Kanten neu.",
      "Die dicht gewebte Bio-Popeline bleibt glatt, fühlt sich leicht an und lässt sich sowohl elegant als auch lässig kombinieren.",
    ],
    Features: [
      "Dichte Bio-Popeline",
      "Rückenpasse mit Bewegungsfalte",
      "Perlmuttfarbene Knöpfe",
      "Verlängertes Rückenteil",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Gerade, leicht weit",
      care: "40 °C Pflegeleicht",
      origin: "Türkei",
      certification: "GOTS",
    },
    tags: ["bio-baumwolle", "popeline", "business", "damen"],
  }),
  createProduct({
    id: 5,
    sku: "HN-W-005",
    slug: "niva-cardigan",
    name: "Niva Feinstrick-Cardigan",
    category: "Damen",
    subcategory: "Strickjacken",
    price: "119.90",
    rating: 4.9,
    reviews: 148,
    badges: ["Liebling"],
    colors: ["Hafer", "Pinie", "Marine"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Niva ist ein leichter Feinstrick-Cardigan für wechselhafte Tage und sanfte Lagenlooks.",
      "Die Mischung aus Wolle und Bio-Baumwolle wärmt, ohne schwer zu wirken, und behält dauerhaft ihre Form.",
    ],
    Features: [
      "Feiner Glattstrick",
      "Tiefe V-Linie",
      "Gerippte Abschlüsse",
      "Tonal eingefärbte Knöpfe",
    ],
    attributes: {
      material: "70% Schurwolle, 30% Bio-Baumwolle",
      fit: "Gerade",
      care: "Wollwaschgang kalt",
      origin: "Italien",
      certification: "Rückverfolgbare Wolle",
    },
    tags: ["wolle", "bio-baumwolle", "strick", "damen"],
  }),
  createProduct({
    id: 6,
    sku: "HN-W-006",
    slug: "sana-wide-leg-jeans",
    name: "Sana Wide-Leg Jeans aus Bio-Denim",
    category: "Damen",
    subcategory: "Jeans",
    price: "129.90",
    rating: 4.7,
    reviews: 117,
    badges: ["Bestseller"],
    colors: ["Mittelblau", "Raw Indigo"],
    size: ["25", "26", "27", "28", "29", "30", "31", "32", "33", "34"],
    description: [
      "Die Sana Jeans sitzt hoch in der Taille und fällt ab der Hüfte in ein weites, gerades Bein.",
      "Ein Hauch Stretch ergänzt den festen Bio-Denim und sorgt dafür, dass die klare Silhouette bequem bleibt.",
    ],
    Features: [
      "Hoher Bund",
      "Weites, gerades Bein",
      "Klassische Five-Pocket-Form",
      "Metallteile mit reduziertem Finish",
    ],
    attributes: {
      material: "99% Bio-Baumwolle, 1% Elasthan",
      fit: "High Waist, Wide Leg",
      care: "30 °C, auf links waschen",
      origin: "Türkei",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["denim", "bio-baumwolle", "wide-leg", "damen"],
  }),
  createProduct({
    id: 7,
    sku: "HN-W-007",
    slug: "tara-twillhose",
    name: "Tara Twillhose aus Bio-Baumwolle",
    category: "Damen",
    subcategory: "Hosen",
    price: "109.90",
    rating: 4.6,
    reviews: 69,
    badges: ["Neu"],
    colors: ["Sandstein", "Olive", "Schwarz"],
    size: ["34", "36", "38", "40", "42", "44", "46"],
    description: [
      "Tara kombiniert einen präzisen Bund mit weich gebürstetem Bio-Twill und einem dezent zulaufenden Bein.",
      "Die Hose ist robust genug für jeden Tag und wirkt dank verdecktem Verschluss angenehm aufgeräumt.",
    ],
    Features: [
      "Gebürsteter Stretch-Twill",
      "Verdeckter Hakenverschluss",
      "Zwei schräge Eingrifftaschen",
      "Formgebende Gesäßabnäher",
    ],
    attributes: {
      material: "98% Bio-Baumwolle, 2% Elasthan",
      fit: "Regular Tapered",
      care: "40 °C Pflegeleicht",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["twill", "hose", "bio-baumwolle", "damen"],
  }),
  createProduct({
    id: 8,
    sku: "HN-W-008",
    slug: "liora-midirock",
    name: "Liora Leinen-Midirock",
    category: "Damen",
    subcategory: "Röcke",
    price: "99.90",
    rating: 4.7,
    reviews: 58,
    badges: ["Sommerfavorit"],
    colors: ["Zimt", "Schwarz", "Natur"],
    size: ["34", "36", "38", "40", "42", "44", "46"],
    description: [
      "Der Liora Rock schwingt weich bis zur Wade und zeigt die lebendige Struktur reinen Leinens.",
      "Ein glatter Vorderbund trifft auf einen elastischen Einsatz im Rücken und verbindet Eleganz mit Bewegungsfreiheit.",
    ],
    Features: [
      "Leicht ausgestellte Midi-Länge",
      "Elastischer Rückenbund",
      "Nahttaschen an beiden Seiten",
      "Atmungsaktives Naturmaterial",
    ],
    attributes: {
      material: "100% Leinen",
      fit: "A-Linie",
      care: "30 °C Feinwäsche",
      origin: "Litauen",
      certification: "Europäischer Flachs",
    },
    tags: ["leinen", "midirock", "sommer", "damen"],
  }),
  createProduct({
    id: 9,
    sku: "HN-W-009",
    slug: "mara-wickelkleid",
    name: "Mara Jersey-Wickelkleid",
    category: "Damen",
    subcategory: "Kleider",
    price: "119.90",
    rating: 4.8,
    reviews: 104,
    badges: ["Bestseller"],
    colors: ["Waldgrün", "Beere", "Nachtblau"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Mara fällt aus weichem Bio-Jersey in eine feminine Wickelform, die sich individuell anpassen lässt.",
      "Der leicht ausgestellte Rock und der sichere Innenverschluss geben dem Kleid Bewegung und zuverlässigen Halt.",
    ],
    Features: [
      "Echte Wickelkonstruktion",
      "Verdeckter Innenbinder",
      "Dreiviertelärmel",
      "Weich fließender Rock",
    ],
    attributes: {
      material: "95% Bio-Baumwolle, 5% Elasthan",
      fit: "Tailliert",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["jersey", "wickelkleid", "bio-baumwolle", "damen"],
  }),
  createProduct({
    id: 10,
    sku: "HN-W-010",
    slug: "soley-strickkleid",
    name: "Soley Strickkleid aus Bio-Baumwolle",
    category: "Damen",
    subcategory: "Kleider",
    price: "139.90",
    rating: 4.6,
    reviews: 61,
    badges: ["Neu"],
    colors: ["Karamell", "Graphit", "Moos"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Das Soley Kleid ist aus kompaktem Bio-Baumwollstrick gefertigt und zeichnet eine ruhige, lange Linie.",
      "Seitliche Schlitze und eine subtile Taillenform geben Bewegungsfreiheit, ohne die minimalistische Wirkung zu stören.",
    ],
    Features: [
      "Kompakter Feinstrick",
      "Sanft geformte Taille",
      "Seitliche Gehschlitze",
      "Gerippter Rundhalsausschnitt",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Figurnah, gerade",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["strickkleid", "bio-baumwolle", "midi", "damen"],
  }),
  createProduct({
    id: 11,
    sku: "HN-W-011",
    slug: "alma-wollmantel",
    name: "Alma Mantel aus reiner Schurwolle",
    category: "Damen",
    subcategory: "Mäntel & Jacken",
    price: "249.90",
    rating: 4.9,
    reviews: 87,
    badges: ["Premium Naturfaser"],
    colors: ["Kamel", "Nachtblau", "Steingrau"],
    size: ["34", "36", "38", "40", "42", "44", "46"],
    description: [
      "Alma ist ein weich gebürsteter Wollmantel mit großzügigem Revers und ausgewogenem, geradem Fall.",
      "Die natürliche Wärme der Schurwolle und ein glattes Pflanzenfaserfutter machen ihn zum langlebigen Begleiter durch den Winter.",
    ],
    Features: [
      "Zweireihige Knopfleiste",
      "Großzügiges Revers",
      "Zwei tiefe Leistentaschen",
      "Futter aus Pflanzenfaser",
    ],
    attributes: {
      material: "Oberstoff 100% Schurwolle; Futter 100% Viskose",
      fit: "Gerade, knielang",
      care: "Professionelle Reinigung",
      origin: "Rumänien",
      certification: "Rückverfolgbare Wolle",
    },
    tags: ["schurwolle", "mantel", "winter", "damen"],
  }),
  createProduct({
    id: 12,
    sku: "HN-M-001",
    slug: "jaro-jerseyshirt",
    name: "Jaro Jersey-Shirt aus Bio-Baumwolle",
    category: "Herren",
    subcategory: "Shirts",
    price: "39.90",
    rating: 4.8,
    reviews: 171,
    badges: ["Bestseller"],
    colors: ["Naturweiß", "Wald", "Schwarz", "Marine"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Jaro ist ein ausgewogen geschnittenes T-Shirt aus weichem, dichtem Bio-Baumwolljersey.",
      "Ein verstärkter Ausschnitt und saubere Doppelnähte machen das schlichte Shirt dauerhaft alltagstauglich.",
    ],
    Features: [
      "Mittelschwerer Single-Jersey",
      "Stabiler Rundhalsausschnitt",
      "Weiches Nackenband",
      "Formbeständige Doppelnähte",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Regular Fit",
      care: "40 °C Pflegeleicht",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["bio-baumwolle", "t-shirt", "basic", "herren"],
  }),
  createProduct({
    id: 13,
    sku: "HN-M-002",
    slug: "elio-leinenhemd",
    name: "Elio Leinenhemd",
    category: "Herren",
    subcategory: "Hemden",
    price: "99.90",
    originalPrice: "129.90",
    rating: 4.7,
    reviews: 76,
    badges: ["Sale", "Sommerfavorit"],
    colors: ["Natur", "Marine", "Salbei"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Das Elio Hemd bringt die luftige Struktur von Leinen in einen klaren, entspannten Schnitt.",
      "Der weiche Resortkragen und die natürlichen Farbnuancen passen zu freien Tagen ebenso wie zu sommerlichen Abenden.",
    ],
    Features: [
      "Weicher Resortkragen",
      "Brusttasche mit feiner Kante",
      "Natürlich kühlendes Gewebe",
      "Vorgewaschener Griff",
    ],
    attributes: {
      material: "100% Leinen",
      fit: "Relaxed Fit",
      care: "30 °C Feinwäsche",
      origin: "Litauen",
      certification: "Europäischer Flachs",
    },
    tags: ["sale", "leinen", "hemd", "sommer", "herren"],
  }),
  createProduct({
    id: 14,
    sku: "HN-M-003",
    slug: "miro-hanf-sweatshirt",
    name: "Miro Hanf-Sweatshirt",
    category: "Herren",
    subcategory: "Sweatshirts",
    price: "99.90",
    rating: 4.6,
    reviews: 64,
    badges: ["Naturfaser"],
    colors: ["Rauchblau", "Olive", "Stein"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Miro verbindet griffigen Hanf mit weicher Bio-Baumwolle zu einem atmungsaktiven Sweatstoff ohne schwere Innenseite.",
      "Der reduzierte Schnitt mit Raglanärmeln bietet Bewegungsfreiheit und entwickelt mit der Zeit eine individuelle Patina.",
    ],
    Features: [
      "Leichter Hanf-Sweat",
      "Bequeme Raglanärmel",
      "Flache Seitennähte",
      "Elastische Rippabschlüsse",
    ],
    attributes: {
      material: "70% Bio-Baumwolle, 30% Hanf",
      fit: "Regular Fit",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["hanf", "sweatshirt", "bio-baumwolle", "herren"],
  }),
  createProduct({
    id: 15,
    sku: "HN-M-004",
    slug: "nils-merino-pullover",
    name: "Nils Merino-Pullover",
    category: "Herren",
    subcategory: "Pullover",
    price: "129.90",
    rating: 4.9,
    reviews: 132,
    badges: ["Bestseller"],
    colors: ["Basalt", "Ziegel", "Marine"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Nils wird aus feiner Merinowolle glatt gestrickt und wärmt, ohne aufzutragen.",
      "Die klare Form lässt sich unter einem Sakko tragen, bleibt aber auch solo angenehm weich und temperaturausgleichend.",
    ],
    Features: [
      "Feiner Glattstrick",
      "Gerippter Rundhalsausschnitt",
      "Fully-fashioned Abschlüsse",
      "Temperaturausgleichende Faser",
    ],
    attributes: {
      material: "100% Merinowolle",
      fit: "Regular Fit",
      care: "Wollwaschgang kalt",
      origin: "Italien",
      certification: "Rückverfolgbare Wolle",
    },
    tags: ["merino", "pullover", "feinstrick", "herren"],
  }),
  createProduct({
    id: 16,
    sku: "HN-M-005",
    slug: "jona-straight-jeans",
    name: "Jona Straight Jeans aus Bio-Denim",
    category: "Herren",
    subcategory: "Jeans",
    price: "129.90",
    rating: 4.7,
    reviews: 119,
    badges: ["Bestseller"],
    colors: ["Raw Indigo", "Mittelblau"],
    size: ["30", "31", "32", "33", "34", "36", "38"],
    description: [
      "Jona ist eine gerade geschnittene Five-Pocket-Jeans aus festem Bio-Denim mit minimalem Stretchanteil.",
      "Die Waschung bleibt bewusst zurückhaltend, damit die Hose beim Tragen ihre eigene, natürliche Zeichnung entwickelt.",
    ],
    Features: [
      "Gerades Bein",
      "Mittlere Bundhöhe",
      "Klassische Five-Pocket-Form",
      "Kontrastarme Nähte",
    ],
    attributes: {
      material: "99% Bio-Baumwolle, 1% Elasthan",
      fit: "Straight Fit",
      care: "30 °C, auf links waschen",
      origin: "Türkei",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["denim", "bio-baumwolle", "straight", "herren"],
  }),
  createProduct({
    id: 17,
    sku: "HN-M-006",
    slug: "timo-cordhose",
    name: "Timo Cordhose aus Bio-Baumwolle",
    category: "Herren",
    subcategory: "Hosen",
    price: "119.90",
    rating: 4.6,
    reviews: 71,
    badges: ["Wieder da"],
    colors: ["Hasel", "Pinie", "Tiefblau"],
    size: ["46", "48", "50", "52", "54", "56"],
    description: [
      "Die Timo Hose besteht aus samtigem Feincord, der Struktur zeigt und dennoch angenehm leicht bleibt.",
      "Ein moderat zulaufendes Bein und der komfortable Sitz machen sie zur warmen Alternative für den Alltag.",
    ],
    Features: [
      "Weicher Feincord",
      "Seitliche Eingrifftaschen",
      "Zwei geknöpfte Gesäßtaschen",
      "Verstärkte Gürtelschlaufen",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Regular Tapered",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["cord", "bio-baumwolle", "hose", "herren"],
  }),
  createProduct({
    id: 18,
    sku: "HN-M-007",
    slug: "lenn-woll-overshirt",
    name: "Lenn Woll-Overshirt",
    category: "Herren",
    subcategory: "Jacken",
    price: "179.90",
    rating: 4.8,
    reviews: 89,
    badges: ["Recycelte Wolle"],
    colors: ["Geröll", "Marine", "Dunkelgrün"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Lenn ist halb Hemd, halb leichte Jacke und wird aus einem weichen Gewebe mit hohem Recyclingwoll-Anteil gefertigt.",
      "Die aufgesetzten Taschen und der gerade Saum geben dem warmen Overshirt einen funktionalen, ruhigen Ausdruck.",
    ],
    Features: [
      "Wärmendes Wollmischgewebe",
      "Zwei aufgesetzte Brusttaschen",
      "Gerader Saum",
      "Knöpfe in Hornoptik",
    ],
    attributes: {
      material: "80% recycelte Wolle, 20% Bio-Baumwolle",
      fit: "Relaxed Fit",
      care: "Professionelle Reinigung",
      origin: "Rumänien",
      certification: "Zertifizierte Recyclingfasern",
    },
    tags: ["recycelte-wolle", "overshirt", "layering", "herren"],
  }),
  createProduct({
    id: 19,
    sku: "HN-M-008",
    slug: "arvid-wetterparka",
    name: "Arvid Wetterparka",
    category: "Herren",
    subcategory: "Mäntel & Jacken",
    price: "229.90",
    rating: 4.7,
    reviews: 95,
    badges: ["Wasserabweisend"],
    colors: ["Moos", "Schwarz", "Ton"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Arvid schützt mit dicht gewebter Bio-Baumwolle und einer fluorfreien Imprägnierung vor Wind und kurzen Schauern.",
      "Die regulierbare Kapuze, verdeckte Taschen und ein herausnehmbares Steppfutter begleiten wechselndes Wetter ohne unnötiges Volumen.",
    ],
    Features: [
      "Fluorfreie wasserabweisende Ausrüstung",
      "Verstellbare Kapuze",
      "Herausnehmbares Steppfutter",
      "Zweiwege-Reißverschluss",
    ],
    attributes: {
      material: "Oberstoff 100% Bio-Baumwolle; Futter 100% recyceltes Polyester",
      fit: "Regular Fit",
      care: "30 °C Schonwäsche",
      origin: "Rumänien",
      certification: "GOTS-zertifizierter Oberstoff",
    },
    tags: ["parka", "bio-baumwolle", "wasserabweisend", "herren"],
  }),
  createProduct({
    id: 20,
    sku: "HN-M-009",
    slug: "mika-chino",
    name: "Mika Relaxed Chino",
    category: "Herren",
    subcategory: "Hosen",
    price: "99.90",
    rating: 4.6,
    reviews: 82,
    badges: ["Alltag"],
    colors: ["Stein", "Marine", "Tabak"],
    size: ["46", "48", "50", "52", "54", "56"],
    description: [
      "Mika ist eine entspannte Chino aus elastischem Bio-Twill mit etwas mehr Raum an Hüfte und Oberschenkel.",
      "Der klare Bund und das sanft schmaler werdende Bein sorgen trotz hoher Bewegungsfreiheit für eine gepflegte Silhouette.",
    ],
    Features: [
      "Elastischer Bio-Twill",
      "Verdeckter Bundverschluss",
      "Schräge Eingrifftaschen",
      "Paspelierte Gesäßtaschen",
    ],
    attributes: {
      material: "97% Bio-Baumwolle, 3% Elasthan",
      fit: "Relaxed Tapered",
      care: "40 °C Pflegeleicht",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["chino", "twill", "bio-baumwolle", "herren"],
  }),
  createProduct({
    id: 21,
    sku: "HN-K-001",
    slug: "lino-langarmshirt",
    name: "Lino Langarmshirt aus Bio-Baumwolle",
    category: "Junior",
    subcategory: "Shirts",
    price: "29.90",
    rating: 4.9,
    reviews: 143,
    badges: ["Kinderliebling"],
    colors: ["Löwenzahn", "Ozean", "Salbei"],
    size: ["98", "104", "110", "116", "122", "128", "134", "140", "146", "152"],
    description: [
      "Lino ist ein weiches Langarmshirt für Entdeckertage, Pausen und alles dazwischen.",
      "Der dehnbare Bio-Jersey und flache Nähte lassen viel Bewegungsfreiheit und fühlen sich sanft auf empfindlicher Haut an.",
    ],
    Features: [
      "Weicher Bio-Jersey",
      "Flache Seitennähte",
      "Elastischer Halsausschnitt",
      "Formstabile Ärmelbündchen",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Bequem",
      care: "40 °C Buntwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["bio-baumwolle", "langarmshirt", "weich", "kinder"],
  }),
  createProduct({
    id: 22,
    sku: "HN-K-002",
    slug: "fia-strickjacke",
    name: "Fia Strickjacke aus Bio-Baumwolle",
    category: "Junior",
    subcategory: "Strick",
    price: "59.90",
    originalPrice: "74.90",
    rating: 4.8,
    reviews: 91,
    badges: ["Sale", "Neu"],
    colors: ["Creme", "Beere", "Fjordblau"],
    size: ["92", "98", "104", "110", "116", "122", "128", "134", "140"],
    description: [
      "Fia ist eine unkomplizierte Strickjacke aus atmungsaktiver Bio-Baumwolle mit fühlbar weicher Struktur.",
      "Große Knöpfe lassen sich leicht greifen, während stabile Rippenbündchen beim Spielen sicher sitzen.",
    ],
    Features: [
      "Weicher Strukturstrick",
      "Griffige Knöpfe",
      "Elastische Rippenbündchen",
      "Kratzt nicht auf der Haut",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Gerade, bequem",
      care: "30 °C Schonwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: [
      "sale",
      "bio-baumwolle",
      "strickjacke",
      "layering",
      "kinder",
    ],
  }),
  createProduct({
    id: 23,
    sku: "HN-K-003",
    slug: "noa-musselinhose",
    name: "Noa Musselin-Schlupfhose",
    category: "Junior",
    subcategory: "Hosen",
    price: "39.90",
    rating: 4.7,
    reviews: 78,
    badges: ["Sommerfavorit"],
    colors: ["Sand", "Salbei", "Wolkenblau"],
    size: ["92", "98", "104", "110", "116", "122", "128", "134", "140"],
    description: [
      "Die Noa Hose besteht aus doppellagigem Musselin, der luftig ist und mit jeder Wäsche weicher wird.",
      "Ein elastischer Bund mit weicher Kordel macht selbstständiges Anziehen einfach und hält beim Toben angenehm mit.",
    ],
    Features: [
      "Luftiger Doppel-Musselin",
      "Elastischer Schlupfbund",
      "Weiche Baumwollkordel",
      "Zwei praktische Taschen",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Locker",
      care: "40 °C Buntwäsche",
      origin: "Türkei",
      certification: "GOTS",
    },
    tags: ["musselin", "bio-baumwolle", "hose", "kinder"],
  }),
  createProduct({
    id: 24,
    sku: "HN-K-004",
    slug: "mila-sweatkleid",
    name: "Mila Sweatkleid aus Bio-Baumwolle",
    category: "Junior",
    subcategory: "Kleider",
    price: "49.90",
    rating: 4.8,
    reviews: 102,
    badges: ["Kinderliebling"],
    colors: ["Altrosa", "Kornblume", "Moos"],
    size: ["98", "104", "110", "116", "122", "128", "134", "140", "146", "152"],
    description: [
      "Mila ist ein weiches Sweatkleid mit lockerer Taille und einem Rock, der jede Bewegung mitmacht.",
      "Die innen angeraute Bio-Baumwolle wärmt an kühlen Tagen, ohne schwer oder steif zu sein.",
    ],
    Features: [
      "Weich angeraute Innenseite",
      "Elastische Taillennaht",
      "Seitliche Eingrifftaschen",
      "Formstabile Bündchen",
    ],
    attributes: {
      material: "95% Bio-Baumwolle, 5% Elasthan",
      fit: "Locker, leicht ausgestellt",
      care: "40 °C Buntwäsche",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["sweat", "kleid", "bio-baumwolle", "kinder"],
  }),
  createProduct({
    id: 25,
    sku: "HN-K-005",
    slug: "tavi-wollfleece",
    name: "Tavi Wollfleece-Jacke",
    category: "Junior",
    subcategory: "Jacken",
    price: "89.90",
    rating: 4.9,
    reviews: 116,
    badges: ["Naturwarm"],
    colors: ["Rost", "Marine", "Wald"],
    size: ["98", "104", "110", "116", "122", "128", "134", "140", "146", "152"],
    description: [
      "Tavi hält mit flauschigem Wollfleece natürlich warm und reguliert Feuchtigkeit bei Bewegung.",
      "Ein hoher Kragen, weiche Einfassungen und ein Kinnschutz machen die Jacke zur komfortablen Lage für draußen.",
    ],
    Features: [
      "Flauschiges Wollfleece",
      "Hoher schützender Kragen",
      "Reißverschluss mit Kinnschutz",
      "Weiche Baumwolleinfassungen",
    ],
    attributes: {
      material: "100% Schurwolle; Einfassungen 100% Bio-Baumwolle",
      fit: "Bequem",
      care: "Wollwaschgang kalt",
      origin: "Deutschland",
      certification: "Rückverfolgbare Wolle",
    },
    tags: ["wollfleece", "jacke", "naturwarm", "kinder"],
  }),
  createProduct({
    id: 26,
    sku: "HN-A-001",
    slug: "sorra-strickschal",
    name: "Sorra Rippstrick-Schal",
    category: "Accessoires",
    subcategory: "Schals",
    price: "59.90",
    rating: 4.8,
    reviews: 88,
    badges: ["Unisex"],
    colors: ["Hafer", "Olive", "Pflaume"],
    size: ["Einheitsgröße"],
    description: [
      "Sorra ist ein großzügiger Rippstrick-Schal aus einer weichen Mischung natürlicher Fasern.",
      "Die plastische Struktur speichert Wärme, bleibt atmungsaktiv und ergänzt klare Winterlooks mit ruhiger Farbe.",
    ],
    Features: [
      "Voluminöser Rippstrick",
      "Weicher, hautfreundlicher Griff",
      "Sauber gestrickte Kanten",
      "Für Damen und Herren",
    ],
    attributes: {
      material: "70% Merinowolle, 30% Bio-Baumwolle",
      fit: "180 × 32 cm",
      care: "Wollwaschgang kalt",
      origin: "Italien",
      certification: "Rückverfolgbare Wolle und GOTS-Baumwolle",
    },
    tags: ["schal", "merino", "bio-baumwolle", "unisex"],
  }),
  createProduct({
    id: 27,
    sku: "HN-U-001",
    slug: "luma-soft-bh",
    name: "Luma Soft-BH aus Bio-Baumwolle",
    category: "Wäsche",
    subcategory: "Damenwäsche",
    price: "44.90",
    originalPrice: "54.90",
    rating: 4.8,
    reviews: 96,
    badges: ["Sale", "Ohne Bügel"],
    colors: ["Salbeigrün", "Naturweiß", "Puder"],
    size: ["70B", "75B", "75C", "80B", "80C", "80D", "85C", "85D"],
    description: [
      "Luma schmiegt sich mit weichem Bio-Baumwolljersey an den Körper und gibt sanften Halt ganz ohne Bügel.",
      "Breite verstellbare Träger, doppellagige Cups und ein elastisches Unterbrustband begleiten den Alltag ohne einzuengen.",
    ],
    Features: [
      "Bügellose, ungepolsterte Form",
      "Doppellagige Jersey-Cups",
      "Breite verstellbare Träger",
      "Weiches elastisches Unterbrustband",
    ],
    attributes: {
      material: "95% Bio-Baumwolle, 5% Elasthan",
      fit: "Sanfter Halt, ohne Bügel",
      care: "30 °C Schonwäsche im Wäschenetz",
      origin: "Portugal",
      certification: "GOTS-zertifizierte Baumwolle",
    },
    tags: ["sale", "bio-baumwolle", "soft-bh", "wäsche"],
  }),
  createProduct({
    id: 28,
    sku: "HN-U-002",
    slug: "nalu-schlafset",
    name: "Nalu Jersey-Schlafset",
    category: "Wäsche",
    subcategory: "Nachtwäsche",
    price: "89.90",
    rating: 4.9,
    reviews: 112,
    badges: ["Neu"],
    colors: ["Hafer", "Nebelblau", "Rosenholz"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Das zweiteilige Nalu Schlafset verbindet ein entspanntes Henley-Oberteil mit einer weich fallenden, geraden Hose.",
      "Atmungsaktiver Bio-Jersey fühlt sich nachts sanft an und macht das Set zugleich zu einer ruhigen Wahl für gemütliche Stunden zu Hause.",
    ],
    Features: [
      "Langarmshirt mit kurzer Knopfleiste",
      "Gerade Hose mit weichem Elastikbund",
      "Atmungsaktiver Single-Jersey",
      "Flache, hautfreundliche Nähte",
    ],
    attributes: {
      material: "100% Bio-Baumwolle",
      fit: "Locker und gerade",
      care: "40 °C Buntwäsche",
      origin: "Portugal",
      certification: "GOTS",
    },
    tags: ["nachtwäsche", "loungewear", "bio-baumwolle", "wäsche"],
  }),
  createProduct({
    id: 29,
    sku: "HN-H-001",
    slug: "merea-leinenbettwaesche",
    name: "Merea Leinen-Bettwäsche",
    category: "Home",
    subcategory: "Bettwäsche",
    price: "149.90",
    originalPrice: "189.90",
    rating: 4.8,
    reviews: 74,
    badges: ["Sale", "Naturfaser"],
    colors: ["Ton", "Natur", "Salbei"],
    size: ["135 × 200 cm", "155 × 220 cm", "200 × 200 cm"],
    description: [
      "Merea wird aus gewaschenem Leinen gefertigt und verbindet einen angenehm kühlen Griff mit lässiger, natürlicher Struktur.",
      "Der Deckenbezug und die passenden Kissenhüllen werden mit kleinen tonalen Knöpfen geschlossen und mit jeder Wäsche weicher.",
    ],
    Features: [
      "Set aus Deckenbezug und zwei Kissenhüllen",
      "Vorgewaschene, weiche Oberfläche",
      "Temperaturausgleichend und atmungsaktiv",
      "Tonale Knopfleiste am Fußende",
    ],
    attributes: {
      material: "100% Leinen",
      fit: "In drei Deckengrößen erhältlich",
      care: "40 °C Feinwäsche",
      origin: "Litauen",
      certification: "Europäischer Flachs",
    },
    tags: ["sale", "leinen", "bettwäsche", "home"],
  }),
  createProduct({
    id: 30,
    sku: "HN-H-002",
    slug: "wela-merinodecke",
    name: "Wela Decke aus Merinowolle",
    category: "Home",
    subcategory: "Decken",
    price: "129.90",
    rating: 4.9,
    reviews: 77,
    badges: ["Neu"],
    colors: ["Moos", "Hafer", "Lehm"],
    size: ["140 × 200 cm"],
    description: [
      "Wela ist eine großzügige Wolldecke mit feiner Fischgratstruktur, weichem Flor und kurzen, zurückhaltenden Fransen.",
      "Reine Merinowolle speichert natürliche Wärme, bleibt atmungsaktiv und bringt ruhige Farbe in Schlaf- und Wohnräume.",
    ],
    Features: [
      "Feine Fischgrat-Webstruktur",
      "Kurze gedrehte Fransen",
      "Temperaturausgleichende Naturfaser",
      "Sauber eingefasste Längskanten",
    ],
    attributes: {
      material: "100% Merinowolle",
      fit: "140 × 200 cm",
      care: "Wollwaschgang kalt",
      origin: "Italien",
      certification: "Rückverfolgbare Wolle",
    },
    tags: ["merino", "wolldecke", "naturwarm", "home"],
  }),
];

export default productData;
